import ServicePageLayout from "@/components/ServicePageLayout";

export default function ExecutiveSearchPage() {
  return (
    <ServicePageLayout
      testId="page-executive-search"
      eyebrow="ArcPoint Executive Search"
      title="Executive Search."
      intro={[
        "Leadership appointments have disproportionate consequences.",
        "ArcPoint runs founder-led retained searches for organisations looking to appoint exceptional senior operators across board, C-suite and director-level leadership.",
        "Every mandate is handled personally, discreetly and with a deliberately narrow search strategy built around the business outcome behind the appointment.",
      ]}
      areasTitle="Board, C-Suite and Director-level appointments."
      areas={[
        "CEO & Managing Director",
        "Chief Operating Officer",
        "Chief Commercial Officer",
        "Chief Revenue Officer",
        "Chief Product Officer",
        "Board & Director appointments",
      ]}
      deepTitle="A search built around the mandate, not the database."
      deepBody={[
        "We combine direct market mapping, targeted headhunting, existing senior-level relationships and detailed qualification to identify individuals whose experience genuinely matches the commercial challenge.",
        "We deliberately work on a limited number of assignments so each mandate receives founder-level attention from briefing through to appointment.",
      ]}
      ctaLabel="Discuss a confidential search"
    />
  );
}
